export default __webpack_public_path__ + "static/media/expert-bg.910c67e6.svg";